import { computed, Directive, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ArrowBehaviours, MaskConfigOptions, Separators } from '../../../directives/mask-directive/mask-options';
import { DateInputEnum } from '../../../models/date-input.enum';
import { dateFormatToConfiguration, getSeparator, timeFormatToConfiguration } from '../../../utils/dates-utils';

/**
 * Base Editor Custom AgGrid for Date/DateTime/Time Input.
 * It contains common functionalities used by DateCellEditorInlineComponent
 * and DateCellEditorPopupComponent
 *      this.dateInputFormat = this.params['dateInputFormat'] || 'ddMMyy'; // TODO creare funzione per formattare l'imput
        this.timeInputFormat = this.params['timeInputFormat'] || 'hhmm'; // TODO creare funzione per formattare l'imput
        this.dateTimeInputFormat = this.params['dateTimeInputFormat'] || 'hhmm'; // TODO: splittare datetime nei due di sopra
        this.dateSeparator = this.params['dateSeparator'] || '/';
        this.timeSeparator = this.params['timeSeparator'] || ':';
 */
@Directive()
export abstract class MaskedDateCellEditorBaseComponent {
    readonly inputType = input.required<DateInputEnum>();
    readonly timeInputFormat = input.required<string>();
    readonly dateInputFormat = input.required<string>();
    readonly dateTimeInputFormat = input.required<string>();
    readonly dateSeparator = input.required<string>();
    readonly timeSeparator = input.required<string>();
    readonly maskedDateFormControl = input.required<FormControl<string | null>>();
    readonly cellReady = input.required<boolean>();

    readonly maskConfigOptions = computed<MaskConfigOptions>(() => {
        const inputType = this.inputType();
        const timeInputFormat = this.timeInputFormat();
        const dateInputFormat = this.dateInputFormat();
        const dateSeparator = this.dateSeparator();
        const timeSeparator = this.timeSeparator();
        let maskConfigOptions: MaskConfigOptions = {};
        switch (inputType) {
            case DateInputEnum.DATE_TIME:
                maskConfigOptions = {
                    dateConfiguration: dateFormatToConfiguration(dateInputFormat),
                    timeConfiguration: timeFormatToConfiguration(timeInputFormat),
                    dateSeparator: getSeparator(dateSeparator, Separators.slash),
                    timeSeparator: getSeparator(timeSeparator, Separators.colon),
                    dateTimeSeparator: Separators.space,
                };
                break;
            case DateInputEnum.TIME:
                maskConfigOptions = {
                    timeConfiguration: timeFormatToConfiguration(timeInputFormat),
                    timeSeparator: getSeparator(dateSeparator, Separators.colon),
                };
                break;
            case DateInputEnum.DATE:
            default:
                maskConfigOptions = {
                    dateConfiguration: dateFormatToConfiguration(dateInputFormat),
                    dateSeparator: getSeparator(dateSeparator, Separators.slash),
                };
                break;
        }
        maskConfigOptions.arrowBehaviours = ArrowBehaviours.circular_without_position;
        maskConfigOptions.ifNoEntryUseActualDate = true;
        return maskConfigOptions;
    });
}
